import { createContext, useState, useContext, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Notification from "../Components/Other Components/Notification";

const NotificationContext = createContext();

export const NotificationProvider = ({ notificationsEnabled, children }) => {
  const [notifications, setNotifications] = useState([]);

  const showNotification = (message, type = "info", onClick = () => {}) => {
    if (notificationsEnabled) {
      const id = Date.now() + Math.random();
      setNotifications((prev) => [...prev, { message, type, id, onClick }]);
      if (notifications.length > 2) clearNotification(notifications[0].id);
    }
  };

  const clearNotification = useCallback((id) => {
    setNotifications((prev) => {
      notifications.forEach((item) => {});

      return prev.filter((item) => item.id !== id);
    });
  }, []);

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <div className="notification-container">
        <AnimatePresence>
          {notifications.map((notification) => (
            <motion.div
              key={notification.id}
              layout
              initial={{ opacity: 0, y: 100, scale: 0.8 }}
              animate={{
                opacity: 1,
                y: 0,
                scale: 1,
                transition: { type: "spring", damping: 20, stiffness: 200 },
              }}
              exit={{
                opacity: 0,
                x: 100,
                transition: { duration: 0.2 },
              }}
              transition={{
                type: "spring",
                damping: 20,
                stiffness: 200,
                layout: { duration: 0.3, ease: "easeInOut" },
              }}
            >
              <Notification
                NotificationKey={notification.id}
                message={notification.message}
                type={notification.type}
                onClose={clearNotification}
                onClick={() => {
                  notification.onClick();
                  clearNotification(notification.id);
                }}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  return useContext(NotificationContext);
};
